import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var BellOutlineSVG = function BellOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M24.36,12.54A8.53,8.53,0,0,0,17,4.07S17,4,17,4V3a1,1,0,0,0-2,0V4s0,0,0,.06a8.29,8.29,0,0,0-7.37,8.19c0,8.23-4.64,6.47-4.64,11v.92A1.84,1.84,0,0,0,4.86,26h7.69a4,4,0,0,0-.05.5,3.5,3.5,0,0,0,7,0,4,4,0,0,0-.05-.5h7.69A1.84,1.84,0,0,0,29,24.17v-.92C29,18.77,24.47,20.44,24.36,12.54Zm-6.86,14a1.5,1.5,0,0,1-3,0,1.64,1.64,0,0,1,.09-.5h2.82A1.64,1.64,0,0,1,17.5,26.5ZM27,24H5v-.75c0-1.06.3-1.34,1.18-2.17C8,19.37,9.64,17.41,9.64,12.25A6.31,6.31,0,0,1,16,6l.56,0a6.57,6.57,0,0,1,5.8,6.54c.07,5.35,2,7.18,3.46,8.52.88.83,1.18,1.11,1.18,2.17Z"
  }));
};
BellOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BellOutlineSVG);